export default {
    productName: '$t("BOCI[8]")',
    productImg: require('../../../assets/image/astp/7.jpeg'),
    isConfig: true, // 是否在中台配置的

    insuranceName: '$t("BOCI[4]")',
    insuranceDownloadName: '$t("BOCI[4]").pdf',
    insuranceFile: 'https://cps.ssish.com/axa/files/ZY/Insurance.pdf',

    mzsmFile: 'https://cps.ssish.com/axa/files/ZY/zrmc.pdf',

    claimGuideName: '$t("labels.h")',
    claimGuideDownloadName: '中银理赔指引.pdf',
    claimGuideFile: 'https://cps.ssish.com/axa/files/ZY/$t("BOCI[3]").pdf',

    claimFormName: '',
    claimFormDownloadName: '',
    claimFormFile: 'https://cps.ssish.com/axa/files/ZY/$t("BOCI[2]").pdf',

    idTypes: ['1', '2'], // 都是value
    relationshipType: 1,
    relationships: ['1', '2', '3', '4'],
    noCType: true,
    ageRange: '$t("BOCI[5]")'
}